import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';


import HomeUserLanding from './HomeUserLanding';
import BusinessLanding from './BusinessLanding';

import HomeUserOnboarding01 from './onboarding/homeonboarding01';
import HomeUserOnboarding02 from './onboarding/homeonboarding02';
import HomeUserOnboarding015 from './onboarding/homeonboarding015';
import HomeUserOnboardingNew from './onboarding/HomeUserOnboardingNew';

import BusinessUserLoginOld from './login/businessuserlogin_old';

import HomeUserProfile from './profiles/HomeOwnerProfile';

// Create this component
import CheckUser from './register/checkuser';
//import HomeDash from './home/homedash';
import BusinessDashboard from './home/businessdash';
import TestSeach from './search/professionSearch'
import FullEntitySearch from './search/fullEntitySearch';
//import HomeUserOnboarding from './search/professionSearch'; 

import BusinessOnboardingNew from './onboarding/BusinessOnboardingNew';
import BusinessProfile from './profiles/BusinessProfile';
import BusinessProfileNew from './profiles/BusinessProfileNew';
import BusinessProfileNewV2 from './profiles/BusinessProfileNewV2';


// import JobsDashboard from './jobs/JobsDashboard';
import NewJobPage from './jobs/NewJobPage';
import BusinessJobsDashboard from './jobs/BusinessJobsDashboard';
import AddjobsCompleted from './jobs/AddjobsCompleted';

import 'bootstrap/dist/css/bootstrap.min.css';
import './search/search.css';

import MapSearch from './search/mapsearchV2';
import ListSearch from './search/listSearch';

import BusinessReview from './reviews/BusinessReview';
import UploadTest from './reviews/UploadTest';

import Activate from './email/activate';
import Success from './email/success';
import PrivateRoute from './components/Route/privateRoute';

/* MESSAGES */
import HomeMessage from './components/HomeMessage';
import BusinessMessage from './components/Message';

import JobDashboard from './pages/JobDashboard/JobDashboard';
import JobOnboarding from './pages/JobOnboarding/JobOnboarding';
import JobDetail from './pages/JobDetail/JobDetail';
import AddJobWrapper from './pages/jobs/AddJobWrapper';

// Business View Job dashboard
import ModernViewJob from './pages/BusinessJobs/modern/ModernViewJob';

import SubscriptionPage from './subscription/subscriptionPage';
import SuccessPage from './subscription/successPage';
import CancelPage from './subscription/cancelPage';
import SuccessPageMobile from './subscription/successPageMobile';
import CancelPageMobile from './subscription/cancelPageMobile';
import ModernSubscriptionPage from './pages/subscription/ModernSubscriptionPage';



import ForgotPasswordHome from './login/ForgotPasswordHome';
import HomeResetPassword from './login/reset-password/HomeResetPassword';
import BusinessResetPassword from './login/reset-password/BusinessResetPassword';
import ForgotPasswordBusiness from './login/ForgotPasswordBusiness';

import ResourcesHubPage from './pages/Landing/ResourcesHubPage.js';
import EducationLanding from './education/EducationLanding';
import AIConsultants from './education/AIConsultants';
import EducationHub from './education/EducationHub';
import EducationCentre from './education/EducationCentre';

import MeetThePros from './education/MeetThePros';
import VideoPage from './education/VideoPage';
import BusinessLearnMore from './education/BusinessLearnMore';


//import HomeJobsDashboard from './_newprofiles/components/HomeUserJobsDashboard.jsx';
import HomeUserJobsDashboard from './pages/JobDashboard/HomeUserJobsDashboard';
import JobDetailNew from './pages/JobDashboard/JobDetailNew';
import ViewJobQuotes from './pages/JobDashboard/ViewJobQuotes'; // Added for viewing quotes
import MyOneOffJobs from './pages/JobDashboard/MyOneOffJobs';

import MapSearchRedesigned from './search/RedesignedMapResult';

import _bizDashboard from './pages/Dashboards/_BusinessDashboardPureCSS';
import _homeDashboard from './pages/Dashboards/_HomeUserDashboardPureCSS';

import _page404 from './pages/Dashboards/_Page404';
import JobsDesignPureCSS from './pages/BusinessJobs/JobsDesignPureCSS';
import BusinessJobsDashboardPureCSS from './pages/BusinessJobs/BusinessJobsDashboardPureCSS.jsx';

import BusinessPortfoliosDashboard from './pages/BusinessPortfolios/BusinessPortfoliosDashboard';
import BusinessPortfolioDetail from './pages/BusinessPortfolios/BusinessPortfolioDetail';
import AddEditBusinessPortfolio from './pages/BusinessPortfolios/AddEditBusinessPortfolio';
import BusinessReviewsPage from './pages/BusinessReviews/BusinessReviewsPage';
import SavedBusinesses from './pages/Dashboards/SavedBusinesses';
import BusinessLandingPagePureCSS from './_landing/BusinessLandingPagePureCSS';
import HomeLandingPagePureCSS from './_landing/HomeLandingPagePureCSS';
import ModernJobReview from './pages/JobReview/ModernJobReview';

import HomeProfilePureCSS from './profiles/HomeProfilePureCSS';
import BusinessProfilePureCSS from './profiles/BusinessProfilePureCSS';

import BuildStartLandingPage from './pages/Landing/BuildStartLanding';
import BusinessGrowthPage from './pages/Landing/BusinessGrowthPage';
import DevelopersGrowthPage from './pages/Landing/DevelopersGrowthPage';

import BuildStartForProfessionalLanding from './pages/Landing/BuildStartForProfessionals';
import ProjectDashboard from './pages/Projects/ProjectDashboard';
import ProjectDetail from './pages/Projects/ProjectDetail';

import { RoleSelectPage, RegistrationPage, ResetPasswordPage } from './pages/Landing/AuthPages';
import { NewLogin, ForgotPasswordPage } from './pages/Landing/LoginNew';

import JobCreationWizard from './pages/JobDashboard/JobCreationWizard';
import AdminDashboard from './pages/Admin/AdminDashboard';
import AdminRoute from './components/Route/adminRoute';
import AIProjectManager from './pages/Projects/_AIProjectManager';
import SelectProjectTemplate from './pages/Projects/SelectProjectTemplate'; // Import the new component
import ProjectLocation from './pages/Projects/ProjectLocation';
import ConfirmContractors from './pages/Projects/ConfirmContractors'; // Import the new component
import SponsorsPage from './pages/Landing/SponsorsPage';
import UnderConstruction from './pages/Landing/UnderConstruction';

import homemock from './pages/Dashboards/mockup/newhomedashboard';
import bizmock from './pages/Dashboards/mockup/newbizdashboard';

import JobManagementPage from "./pages/JobDashboard/JobManagementPage";
import { BusinessEnquiryPage } from './pages/Leads/BusinessEnquiryPage';
import ConnectSponsorHandler from './pages/Connect/ConnectSponsorHandler';
import SaveSponsorHandler from './pages/Connect/SaveSponsorHandler';

import BusinessOnboardingWizard from './onboarding/BusinessOnboardingWizard.js';
import ContactSupportPage from './pages/Support/ContactSupportPage.jsx';

import ProposedBusinessLanding from './pages/Landing/ProposedBusinessLanding.jsx';

import BusinessGrowthPageNew from './pages/Landing/BusinessGrowthPageNew.jsx';
import DevelopersGrowthPageNew from './pages/Landing/DevelopersGrowthPageNew.jsx';

import ResourcesHubPageNew from './pages/Landing/ResourcesHubPageNew.jsx';

import BusinessLandingFormat from './pages/Landing/bp.jsx';

//import AdvertisementPost from './temp/component/AdvertisementPost';

function App()
{
  return (
    <Router>
      <Routes>

        <Route path="/" element={<BuildStartLandingPage />} />

        <Route path="/under-construction" element={<UnderConstruction />} />
        <Route path="/landing" element={<BuildStartLandingPage />} />
        <Route path="/sponsors" element={<SponsorsPage />} />
        
        <Route path="/contact-business" element={<BusinessEnquiryPage />} />
        <Route path="/connect-sponsor/:businessUserId" element={<ConnectSponsorHandler />} />
        <Route path="/save-sponsor/:businessId" element={<SaveSponsorHandler />} />

        {/* <Route path="/" element={getUser() === "true" ? <HomeUserLanding /> : <PrivateRoute element={HomeUserOnboarding01} />} /> */}
        <Route path="/business-landing-hi" element={<BuildStartForProfessionalLanding />} />
        <Route path="/business-landing-old" element={<BusinessGrowthPage />} />
        <Route path="/business-landing" element={<BusinessGrowthPageNew />} />

        <Route path="/for-developers-old" element={<DevelopersGrowthPage />} />
        <Route path="/for-developers" element={<DevelopersGrowthPageNew />} />
        
        <Route path="/resources-hub" element={<ResourcesHubPageNew />} />
        <Route path="/contact-support" element={<ContactSupportPage />} />

        <Route path="/bp" element={<BusinessLandingFormat />} />

        <Route path="/proposed-resource-hub" element={<ResourcesHubPageNew />} />


        {/* Routes for the Authentication Flow */}
        <Route path="/login" element={<NewLogin />} />
        <Route path="/admin" element={<AdminRoute element={AdminDashboard} />} />
        {/*<Route path="/forgot-password" element={<ForgotPasswordPage />} /> */}
        <Route path="/reset-password" element={<ResetPasswordPage />} />

        <Route path="/select-role" element={<RoleSelectPage />} />
        
        {/* Same RegistrationPage component but pass a different 'role' prop */}
        <Route 
          path="/register/homeowner" 
          element={<RegistrationPage role="homeowner" />} 
        />
        <Route 
          path="/register/business" 
          element={<RegistrationPage role="business" />} 
        />
        <Route 
          path="/register/developer" 
          element={<RegistrationPage role="developer" />} 
        />





        <Route path="/newbusiness" element={<PrivateRoute element={_bizDashboard} />} />
        <Route path="/newhome" element={<PrivateRoute element={_homeDashboard} />} />

        <Route path="/newmockup" element={<PrivateRoute element={homemock} />} />
        <Route path="/newmockupbiz" element={<PrivateRoute element={bizmock} />} />


        <Route path="/map-search" element={<MapSearch />} />
        
        <Route path="/map-search-v2" element={<MapSearch />} />
        <Route path="/list-search" element={<ListSearch />} />
        
        <Route path="/business-user-login-old" element={<BusinessUserLoginOld />} />

        <Route path="/checkuser" element={<CheckUser />} />
        {/*<Route path="/homedash" element={<PrivateRoute element={HomeDash} />} /> */}

        {/*<Route path="/businessdash" element={< PrivateRoute element={BusinessDashboard} />} /> */}
        <Route path="/businessdash" element={< PrivateRoute element={_bizDashboard} />} />
        
        <Route path="/testsearch" element={<TestSeach />} />
        <Route path="/fullsearch" element={<FullEntitySearch />} />


        {/*< BUSINESS ONBOARDING */}
        {/* <Route path="/business-onboarding-new" element={<PrivateRoute element={BusinessOnboardingNew} />} /> */}

        <Route path="/business-onboarding-new" element={<PrivateRoute element={BusinessOnboardingWizard} />} /> 
        <Route path="/business-onboarding-new/:businessId" element={<PrivateRoute element={BusinessOnboardingNew} />} />

        {/*< HOME ONBOARDING */}
        <Route path="/home-user-onboarding-new" element={<PrivateRoute element={HomeUserOnboardingNew} />} />
        <Route path="/home-user-profile/:userId" element={<PrivateRoute element={HomeUserOnboardingNew} />} />


        <Route path="/JobsDashboard" element={<PrivateRoute element={JobDashboard} />} />
        <Route path="/jobs/NewJobPage" element={<PrivateRoute element={NewJobPage} />} />
        <Route path="/jobs/BusinessJobsDashboard" element={<PrivateRoute element={BusinessJobsDashboard} />} />
        <Route path="/AddjobsCompleted" element={<PrivateRoute element={AddjobsCompleted} />} />
        <Route path="/JobOnboarding" element={<PrivateRoute element={JobOnboarding} />} />
        <Route path="/job-detail" element={<PrivateRoute element={JobDetail} />} />

        <Route path="/homeUserProfile" element={<PrivateRoute element={HomeUserProfile} />} />

        
        <Route path="/businessorofileold" element={<PrivateRoute element={BusinessProfile} />} />
        <Route path="/businessProfile" element={<PrivateRoute element={BusinessProfileNewV2} />} />


        <Route path="/reviews/businessreview" element={<BusinessReview />} />
        <Route path="/reviews/uploadtest" element={<UploadTest />} />

        <Route path="/activate" element={<Activate />} />
        <Route path="/success" element={<Success />} />

        <Route path="/home_messages" element={<PrivateRoute element={HomeMessage} />} />
        <Route path="/business_messages" element={<PrivateRoute element={BusinessMessage} />} />

        <Route path="/subscription/subscribe" element={<SubscriptionPage />} />
        <Route path="/subscription/subscribenew" element={<ModernSubscriptionPage />} />

        <Route path="/subscription/success" element={<SuccessPage />} />
        <Route path="/subscription/cancel" element={<CancelPage />} />

        <Route path="/subscription/success_mobile" element={<SuccessPageMobile />} />
        <Route path="/subscription/cancel_mobile" element={<CancelPageMobile />} />


        <Route path="/add-job/*" element={<PrivateRoute element={AddJobWrapper} />} />
        <Route path="/viewjob" element={<PrivateRoute element={ModernViewJob} />} />


        <Route path="/education-home" element={<EducationLanding />} />
        <Route path="/ai-consultants" element={<AIConsultants />} />
        <Route path="/education-hub" element={<EducationHub />} />
        <Route path="/education-centre" element={<EducationCentre />} />
        <Route path="/meetpros" element={<MeetThePros />} />
        <Route path="/videos" element={<VideoPage />} />
        <Route path="/edubiz" element={<BusinessLearnMore />} />

        <Route path="/newhomejobs" element={<PrivateRoute element={HomeUserJobsDashboard} />} />
        
        {/* New Dedicated Page for One Off Jobs */}
        <Route path="/my-jobs" element={<PrivateRoute element={MyOneOffJobs} />} />

        {/* NEW ROUTE for creating a job */}
        <Route path="/job-detail-new" element={<PrivateRoute element={JobCreationWizard} />} />


        <Route path="/job-detail-new/:jobId" element={<PrivateRoute element={JobDetailNew} />} /> {/* For edit mode later */}
        

        {/* ROUTE for editing a job remains the same */}

        
        <Route path="/job/:jobId/quotes" element={<PrivateRoute element={ViewJobQuotes} />} /> {/* Added route for viewing quotes */}
        
        <Route path="/mapresultnew" element={<PrivateRoute element={MapSearchRedesigned} />} />



        <Route path="/projects" element={<PrivateRoute element={ProjectDashboard} />} />
        <Route path="/project/:projectId" element={<PrivateRoute element={ProjectDetail} />} />
        <Route path="/project/:projectId/:jobId" element={<PrivateRoute element={ProjectDetail} />} />

        <Route path="/page404" element={<PrivateRoute element={_page404} />} />

        <Route path="/jobs-design-pure-css" element={<PrivateRoute element={JobsDesignPureCSS} />} />
        <Route path="/business-jobs-dashboard" element={<PrivateRoute element={BusinessJobsDashboardPureCSS} />} />

        <Route path="/business-portfolios" element={<PrivateRoute element={BusinessPortfoliosDashboard} />} />
        <Route path="/business-portfolios/new" element={<PrivateRoute element={AddEditBusinessPortfolio} />} />
        <Route path="/business-portfolios/edit/:portfolioId" element={<PrivateRoute element={AddEditBusinessPortfolio} />} />
        <Route path="/business-portfolios/:portfolioId" element={<PrivateRoute element={BusinessPortfolioDetail} />} />

        <Route path="/business-reviews" element={<PrivateRoute element={BusinessReviewsPage} />} />
        <Route path="/saved-businesses" element={<PrivateRoute element={SavedBusinesses} />} />

        <Route path="/business-landing-pure" element={<BusinessLandingPagePureCSS />} />
        <Route path="/home-landing-pure" element={<HomeLandingPagePureCSS />} />

        <Route path="/job/:jobId/review/:businessId" element={<PrivateRoute element={ModernJobReview} />} />

        <Route path="/home-profile-pure-css" element={<HomeProfilePureCSS isOpen={true} />} />
        <Route path="/business-profile-pure-css" element={<BusinessProfilePureCSS isOpen={true} />} />

        {/*<Route path="/newlanding" element={<MyStartLanding />} /> */}
        


        <Route path="/ai-project-manager" element={<PrivateRoute element={AIProjectManager} />} />
        <Route path="/ai-project-onboarding/select-template" element={<PrivateRoute element={SelectProjectTemplate} />} />
        <Route path="/ai-project-onboarding/location/:templateId" element={<PrivateRoute element={ProjectLocation} />} />
        <Route path="/ai-project-onboarding/confirm-contractors/:templateId" element={<PrivateRoute element={ConfirmContractors} />} />

        <Route path="/job-console/:jobId" element={<PrivateRoute element={JobManagementPage} />} /> 
        
      </Routes>
    </Router>
  );
}

export default App;
